module.exports = __webpack_public_path__ + "media/images/log/log-graph-kyusyu-3a8ec573c5f9f05624f45db5201264ad.svg";